import { CART_MODULE } from "@/api_framework/api_config";
import { ICartListResponse, ICartListResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const useInvoiceCancellationListAPI = () => {
  const configuration = useConfiguration();
  const [cancellationReason, setCancellationReason] = useState<ICartListResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: ICartAPIResponse = await axios
        .get(`${CART_MODULE?.INVOICE_CANCELLATION_REASON?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICartListResponse>) => {
          if (res.data.status === true) {
            setCancellationReason(res.data.data);
            return { status: true, message: "batch" };
          } else {
            setCancellationReason([]);
            return { status: false, message: "cart_not_filtered" };
          }
        })
        .catch((e: AxiosError) => {
          setCancellationReason([]);

          sendCurl(e.config["curlCommand"]);
          // captureError(e)
          return { status: false, message: "cart_not_filtered" };
        });
      return response;
    } catch (e) {
      setCancellationReason([]);
      captureError(e);
    }
  }, [dispatch]);
  return { cancellationReason, execute };
};
